import { render, staticRenderFns } from "./AddFilterForm.vue?vue&type=template&id=38236a8e"
import script from "./AddFilterForm.vue?vue&type=script&lang=js"
export * from "./AddFilterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports